import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'timespan',
})
export class TimespanPipe implements PipeTransform {
  /**
   * Transforms the input value.
   */
  transform(
    value: number | null | undefined,
    format: string,
    base: number = 10000,
  ): string | null {
    if (!value) {
      return null;
    }

    const milleseconds = base;
    const seconds = 1000 * milleseconds;
    const minutes = 60 * seconds;
    const hours = 60 * minutes;
    const days = 24 * hours;

    const fullDays = Math.floor(value / days);
    const fullHours = Math.floor((value - fullDays * days) / hours);
    const fullMinutes = Math.floor((value - fullHours * hours) / minutes);
    const fullSeconds = Math.floor((value - fullMinutes * minutes) / seconds);

    const daysValue = parseFloat((value / days).toFixed(2));
    const hoursValue = parseFloat((value / hours).toFixed(2));
    const minutesValue = parseFloat((value / minutes).toFixed(2));
    const secondsValue = parseFloat((value / seconds).toFixed(2));

    return format
      .replace(/SSS/g, `${secondsValue} s`)
      .replace(/MMM/g, `${minutesValue} min`)
      .replace(/HHH/g, `${hoursValue} h`)
      .replace(/DDD/g, `${daysValue} d`)
      .replace(
        /XXX/g,
        this.getMaximum(
          daysValue,
          hoursValue,
          minutesValue,
          secondsValue,
          true,
        ),
      )
      .replace(/SS/g, fullSeconds ? `${fullSeconds}` : '')
      .replace(/MM/g, fullMinutes ? `${fullMinutes}` : '')
      .replace(/HH/g, fullHours ? `${fullHours}` : '')
      .replace(/DD/g, fullDays ? `${fullDays}` : '')
      .replace(
        /XX/g,
        this.getMaximum(
          daysValue,
          hoursValue,
          minutesValue,
          secondsValue,
          false,
        ),
      )
      .replace(/S/g, `${fullSeconds}`.padStart(2, '0'))
      .replace(/M/g, `${fullMinutes}`.padStart(2, '0'))
      .replace(/H/g, `${fullHours}`.padStart(2, '0'))
      .replace(/D/g, `${fullDays}`.padStart(2, '0'));
  }

  private getMaximum(
    daysValue: number,
    hoursValue: number,
    minutesValue: number,
    secondsValue: number,
    round: boolean,
  ): string {
    if (daysValue > 1) {
      return `${round ? Math.round(daysValue) : daysValue} d`;
    }

    if (hoursValue > 1) {
      return `${round ? Math.round(hoursValue) : hoursValue} h`;
    }

    if (minutesValue > 1) {
      return `${round ? Math.round(minutesValue) : minutesValue} min`;
    }

    if (secondsValue > 1) {
      return `${round ? Math.round(secondsValue) : secondsValue} s`;
    }

    return '';
  }
}
